@if (viewModel(); as vm) {
  <div class="reference-popover_add">
    <div class="reference-popover_add-header">
      <div class="reference-popover_title">{{ 'ReferencePopover.Title' | transloco }}</div>
      @switch (vm.mode) {
        @case ('file') {
          <mat-icon
            class="reference-popover_add-header-icon"
            [icon]="'search'"
            [iconSize]="16"
            [ttTooltip]="'ReferencePopover.SearchTooltip' | transloco"
            (click)="store.switchMode('search')" />
        }
        @case ('search') {
          <mat-icon
            class="reference-popover_add-header-icon"
            data-testid="reference-popover_button-file-upload"
            data-userguide="reference-popover_file-upload-icon"
            [icon]="'upload'"
            [iconSize]="16"
            [ttTooltip]="'ReferencePopover.UploadFileTooltip' | transloco"
            (click)="store.switchMode('file')" />
        }
      }
    </div>
    @switch (vm.mode) {
      @case ('file') {
        <tt-file-drag-drop
          class="reference-popover_add-file"
          [allowedTypes]="['ris', 'bib']"
          [error]="vm.error ? ('ReferencePopover.ExtractError' | transloco) : undefined"
          [file]="vm.file"
          [info]="'DragAndDropLiteratureFiles'"
          (fileChanged)="handleFileChanged($event)" />
      }
      @case ('search') {
        <input
          data-testid="reference-popover_search-input"
          ttInput
          [formControl]="extractOrSearchFormControl"
          [placeholder]="'ReferencePopover.InputPlaceholder' | transloco" />
      }
    }
  </div>
  @if (vm.error && !vm.loading) {
    <span class="reference-popover_error">{{ 'ReferencePopover.SearchError' | transloco }}</span>
  } @else {
    @if (vm.loading) {
      <tt-spinner class="reference-popover_spinner" />
    } @else {
      <div class="reference-popover_search-results-list" [class.reference-popover_search-results-list--static-min-height]="vm.file">
        @if (vm.newReferences.length > 0) {
          @for (selectableReference of vm.newReferences; track selectableReference.reference.id) {
            <tt-reference-card
              [disabled]="selectableReference.disabled"
              [reference]="selectableReference.reference"
              [selectable]="true"
              [selected]="selectableReference.selected"
              (selectReference)="store.selectDeselectReference(selectableReference.reference)" />
          }
        }

        @if (vm.existingReferences.length > 0) {
          <span
            class="reference-popover_search-results-title reference-popover_title"
            data-testid="reference-popover_available-references-title">
            {{ 'ReferencePopover.AvailableReferences' | transloco }}
            @if (vm.disableExisting) {
              <mat-icon [icon]="'info'" [iconSize]="13" [ttTooltip]="'ReferencePopover.AvailableReferencesTooltip' | transloco" />
            }
          </span>
          @for (selectableReference of vm.existingReferences; track selectableReference.reference.id) {
            <tt-reference-card
              [disabled]="selectableReference.disabled || vm.disableExisting"
              [reference]="selectableReference.reference"
              [selectable]="true"
              [selected]="selectableReference.selected"
              [ttTooltip]="vm.disableExisting ? ('ReferencePopover.AvailableReferenceDisabledTooltip' | transloco) : null"
              (selectReference)="store.selectDeselectReference(selectableReference.reference)" />
          }
        }
        @if ((vm.file || vm.searchValue) && !vm.loading && vm.newReferences.length === 0 && vm.existingReferences.length === 0) {
          <span class="reference-popover_no-results">
            {{ 'ReferencePopover.NoResults' | transloco }}
          </span>
        }
      </div>
    }
  }

  <div class="reference-popover_actions">
    <button
      ttButton
      [disabled]="vm.newlySelectedCount === 0"
      [ttTooltip]="vm.newlySelectedCount === 0 ? ('ReferencePopover.AddReferenceButtonDisabled' | transloco) : ''"
      (click)="addReferences(vm.selected)">
      @if (vm.newlySelectedCount > 1) {
        {{ 'ReferencePopover.AddReferencesButton' | transloco }} ({{ vm.newlySelectedCount }})
      } @else {
        {{ 'ReferencePopover.AddReferenceButton' | transloco }}
      }
    </button>
  </div>
}
